import { create } from "zustand";

interface DataType {
  token: string;
  setToken: (val: string) => void;
}
export const useToken = create<DataType>((set) => ({
  token: "",
  setToken: (val) => set({ token: val }),
}));
